export default {
	"exceptionType": {
		"typeName": "类型名称",
		"type": "类型",
		"autoMonitor": "自动监控",
		"exceptionCode": "异常编码",
		"code": "编码",
		"attr": "属性",
		"level": "级别",
		"tabTitle1": "类型信息",
		"defaultLevel": "默认级别",
		"hourLimit": "处理时限",
		"reason": "异常原因",
		"reasonName": "原因名",
		"addTitle": "创建异常类型"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/exceptionType/exceptionType.js